module.exports = __webpack_public_path__ + "img/timesheet-icon-blue.0f37958c.svg";